module.exports = __webpack_public_path__ + "img/TradingView-icon8.554ff89c.svg";